import { IconSearch } from "@tabler/icons-react";
import { BotonExportarExcel, Group, Input, Table, Tbody, Td, Text, Th, Thead, Tr } from "@/components/ui";
import type { TipoDocumentoAdicional } from "@/lib/types";
import { TipoDocumentoRow } from "./TipoDocumentoRow";

/**
 * Tabla del catálogo de tipos de documento (54+ filas) · la búsqueda se
 * aplica en el SERVIDOR (el container la pasa como query param con debounce)
 * y acá solo se pinta la página visible. Cada fila controla su modo edición.
 */
export function TiposDocumentoTable({
  tipos,
  busqueda,
  onBusquedaChange,
  sinResultados,
  hayBusqueda,
  obtenerFilas,
}: {
  tipos: TipoDocumentoAdicional[];
  busqueda: string;
  onBusquedaChange: (b: string) => void;
  sinResultados: boolean;
  hayBusqueda: boolean;
  /** Trae TODAS las páginas con la búsqueda actual · para el export. */
  obtenerFilas: () => Promise<TipoDocumentoAdicional[]>;
}) {
  return (
    <div>
      <Group justify="space-between" className="mb-2" align="flex-start">
        <Input
          placeholder="Buscar tipo…"
          leftSection={<IconSearch size={14} stroke={1.7} />}
          value={busqueda}
          onChange={(e) => onBusquedaChange(e.currentTarget.value)}
          wrapperClassName="max-w-90 flex-1"
        />
        <BotonExportarExcel
          archivo="tipos-documento"
          hoja="Tipos de documento"
          obtenerFilas={obtenerFilas}
          columnas={[
            { header: "Nombre", value: (t) => t.nombre },
            { header: "Orden", value: (t) => t.orden },
            { header: "Estado", value: (t) => (t.activo ? "Activo" : "Inactivo") },
          ]}
        />
      </Group>
      <div className="overflow-x-auto">
        <Table verticalSpacing="sm">
          <Thead>
            <Tr>
              <Th>Nombre</Th>
              <Th>Estado</Th>
              <Th />
            </Tr>
          </Thead>
          <Tbody>
            {tipos.map((t) => (
              <TipoDocumentoRow key={t.id} tipo={t} />
            ))}
            {sinResultados && (
              <Tr>
                <Td colSpan={3}>
                  <Text size="sm" c="dimmed" ta="center" className="py-3">
                    {hayBusqueda ? "Sin resultados para la búsqueda." : 'Sin tipos. Crea el primero con "Nuevo tipo".'}
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </div>
    </div>
  );
}
